import { FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FragmentNames, MyChartPastHistoryHospitalAliases } from '../../codegen';
import './my-chart-past-history-hospital-detail.css';
import DateFormatterUtil from '../../utils/date-utils/date-formatter-util';

@Controller({ fragment: FragmentNames.MY_CHART_PAST_HISTORY_HOSPITAL })
class MyChartPastHistoryHospitalDetailController extends BaseController {

  @Inject(MyChartPastHistoryHospitalAliases.FORM_PAST_HISTORY_HOSPITAL)
    pastHistoryHospitalFormApi!: FormAPI;

  @OnMount(MyChartPastHistoryHospitalAliases.FORM_PAST_HISTORY_HOSPITAL)
  handleMount(event: MountEvent): void {
    const pastHistoryHospitalFormApi = event.target as FormAPI;
    const pastHistorySequence = this.getHistoryRouteParam<Value>('pastHistorySequence');

    HttpService.get(APPLICATION_ENDPOINTS.GET_MC_PAST_HISTORY_HOSPITAL_DETAIL, { pastHistorySequence: pastHistorySequence, patientId: UserContext.patientId })
      .then(response => response.body as Record<string, Value>)
      .then(data => {

        const startDate = data.startDate as string;
        const endDate = data.endDate as string;

        data.disease = data.disease || '-';
        data.startDate = startDate ? DateFormatterUtil.shortDate(startDate.toString()) : '';
        data.endDate = endDate ? DateFormatterUtil.shortDate(endDate.toString()) : '';
        data.notes = data.notes || '-';

        pastHistoryHospitalFormApi.setData(data);
      });
  }

}
export default MyChartPastHistoryHospitalDetailController;